import http from '../../integration/HttpService';
const apiUrl = require('../../config').get(process.env.REACT_APP_ENV).apiUrl;
const apiBase = apiUrl + '/projectManagement/managedServicePool/'

/**
 * getRegionMSContracts - retirive all Managed Services Projects And Crs By Region
 * @returns {Object}  Object of Projects And Crs
 * @param params
 */
export  function getMSProjectsAndCrsByRegion(params){
    const endPoint = apiBase + 'getMSProjectsAndCrsByRegion';
    return  http.post(endPoint, params);
}

/**
 * createRegionMSContract - create region MS contract
 * @returns {Object}  Object of created contract
 * @param params
 */
export  function createRegionMSContract(params){
    const endPoint = apiBase + 'createRegionMSContract';
    return  http.post(endPoint, params);
}

/**
 * createRegionResourceAllocations - create region resource allocations
 * @returns {Object}  Object of created resource allocations
 * @param params
 */
export  function createRegionResourceAllocations(params){
    const endPoint = apiBase + 'createRegionResourceAllocations';
    return  http.post(endPoint, params);
}

/**
 * getRegionMSContracts - retirive all region Managed Services Contracts
 * @returns {Object}  Object of Contracts
 * @param params
 */
export  function getRegionMSContracts(params){
    const endPoint = apiBase + 'getRegionMSContracts';
    return  http.post(endPoint, params);
}

/**
 * getAllContractsByRegion - retirive all contracts By Region
 * @returns {Object}  Object of Projects And Crs
 * @param params
 */
export  function getAllContractsByRegion(params){
    const endPoint = apiBase + 'getAllContractsByRegion';
    return  http.post(endPoint, params);
}

/**
 * removeRegionMSContract - remove region MS contract
 * @returns {Object}  Object of created contract
 * @param params
 */
export  function removeRegionMSContract(params){
    const endPoint = apiBase + 'removeRegionMSContract';
    return  http.post(endPoint, params);
}

/**
 * getAllResourcesByRegion - retirive all resources By Region
 * @returns {Object}  Object of Projects And Crs
 * @param params
 */
export  function getAllResourcesByRegion(params){
    const endPoint = apiBase + 'getAllResourcesByRegion';
    return  http.post(endPoint, params);
}

/**
 * removeRegionMSResource - remove region MS Resource
 * @returns {Object}  Object of created contract
 * @param params
 */
export  function removeRegionMSResource(params){
    const endPoint = apiBase + 'removeRegionMSResource';
    return  http.post(endPoint, params);
}
